/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3SegmentorDeploymentResults } from '../models/V3SegmentorDeploymentResults';
import { HttpFile } from '../http/http';

export class V3ResolveSegmentorIncidentResponse {
    'status'?: string;
    'action'?: string;
    'incidentId'?: string;
    'affectedSegments'?: number;
    'affectedAdvertisers'?: number;
    'resolutionTime'?: Date;
    'deploymentResults'?: V3SegmentorDeploymentResults;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "string",
            "format": ""
        },
        {
            "name": "incidentId",
            "baseName": "incidentId",
            "type": "string",
            "format": ""
        },
        {
            "name": "affectedSegments",
            "baseName": "affectedSegments",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "affectedAdvertisers",
            "baseName": "affectedAdvertisers",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "resolutionTime",
            "baseName": "resolutionTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deploymentResults",
            "baseName": "deploymentResults",
            "type": "V3SegmentorDeploymentResults",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3ResolveSegmentorIncidentResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

